import { ReduxHelper } from 'helpers';
import { ICloseOnlineBooking } from 'models/ICloseOnlinebooking';

export const prefix = 'CLOSE_ONLINE_BOOKING';

export const selectCloseOnlineBooking = ReduxHelper.generateLocalAction<
	ICloseOnlineBooking | undefined
>(`${prefix}/SELECT_CLOSE_ONLINE_BOOKING`);
